export default "__VITE_ASSET__BHvwxHur__"